import React from "react";
import SEO from "@/components/SEO";

/**
 * Shared layout for static policy pages — clean, readable, generous typography.
 */
export default function PolicyLayout({ title, description, path, eyebrow, lastUpdated, children }) {
  return (
    <>
      <SEO title={title + " — PeptiChill"} description={description} path={path} />
      <section className="bg-white py-16 lg:py-24" data-testid={`page-policy-${path.replace("/", "")}`}>
        <div className="container-pc max-w-3xl">
          {eyebrow && <p className="eyebrow">{eyebrow}</p>}
          <h1 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-bold text-navy tracking-tightest leading-[1.05]">
            {title}
          </h1>
          {lastUpdated && (
            <p className="mt-4 text-xs uppercase tracking-widest text-muted">
              Last updated: {lastUpdated}
            </p>
          )}
          <div className="mt-10 prose-policy">{children}</div>
        </div>
      </section>
    </>
  );
}
